export default {"src":"/_next/static/media/neo-offset.fe82c4e9.gif","height":198,"width":328,"blurWidth":0,"blurHeight":0};